import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { IdName } from 'src/app/shared/models/id-name.model';
import { ActiveDirectoryType } from 'src/app/shared/enums/active-directory-type.enum';

@Pipe({
  name: 'activeDirectoryType',
  standalone: false
})
export class ActiveDirectoryTypePipe implements PipeTransform {
  public transform(value: ActiveDirectoryType): string {
    return getActiveDirectoryType(value);
  }
}

export function getActiveDirectoryType(value: ActiveDirectoryType): string {
  switch (value) {
    case ActiveDirectoryType.Azure:
      return 'Azure';
    case ActiveDirectoryType.Adfs:
      return 'Active Directory FS';
    default:
      throw new Error(`Unsupported value for ActiveDirectoryType: ${value}.`);
  }
}

export function getActiveDirectoryTypeList(): IdName[] {
  return enumToList(ActiveDirectoryType, getActiveDirectoryType);
}
